import React, { Component, PropTypes } from 'react';
import ClassNames from 'classnames';

export default class GridContainer extends Component {
  static propTypes = {
    fluid: PropTypes.bool
  };

  static defaultProps = {
    fluid: false
  };

  render() {
    let { className, ...other } = this.props;
    let classes = ClassNames(className, {
      container: !this.props.fluid,
      'container-fluid': this.props.fluid
    });
    return (
      <div className={classes} {...other}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Grid/GridContainer.js